import React from 'react';

interface TableLoaderProps {
  colSpan: number;
  message?: string;
}

export const TableLoader: React.FC<TableLoaderProps> = ({ colSpan, message = 'Loading...' }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-8 text-center" style={{ color: 'var(--color-text-secondary)' }}>
        {message}
      </td>
    </tr>
  );
};

